import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ProjectDetailTooltipModule } from './project-detail-tooltip/project-detail-tooltip.module';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { ForModule } from '@rx-angular/template/for';
import { DayProgressesModule } from '@shared/components/scheduler-calendar/day-progresses/day-progresses.module';
import { SchedulerCalendarComponent } from '@shared/components/scheduler-calendar/scheduler-calendar.component';
import { UnscheduledProjectMenuModule } from '@shared/components/scheduler-calendar/unscheduled-project-menu/unscheduled-project-menu.module';
import { AppDatepickerModule } from '@ui-kit/app-datepicker/app-datepicker.module';
import { ButtonsModule } from '@ui-kit/buttons/buttons.module';
import { LoaderModule } from '@ui-kit/loader/loader.module';
import { CommonPipesModule } from '@ui-kit/pipes/common-pipes.module';

@NgModule({
  declarations: [SchedulerCalendarComponent],
  exports: [SchedulerCalendarComponent],
  imports: [
    CommonModule,
    TranslateUiModule,
    CommonPipesModule,
    LoaderModule,
    DragDropModule,
    MatTooltipModule,
    ProjectDetailTooltipModule,
    MatMenuModule,
    AppDatepickerModule,
    ButtonsModule,
    DayProgressesModule,
    UnscheduledProjectMenuModule,
    ForModule
  ]
})
export class SchedulerCalendarModule {}
